import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function trackQuestions(questions) {
  pushClevertapEvent('Fresh Questionnaires', {
    'Fruit & Vegetables': questions.fruitandvigie,
    'Dairy Products (e.g. milk, cheese, yoghurt)': questions.milk,
    'Meats & Eggs': questions.eggsandmeat,
    'Seafood Products': questions.seafood,
    'FMCG Products': questions.fmcg,
    'Beverage Products (e.g. syrups, premium powders)': questions.drinks,
    'Food Packaging': questions.foodpackage,
    Other: questions.other ? questions.otherfield : '',
    Contact: questions.contact,
  });
}

export function mokaFreshMenu() {
  pushClevertapEvent('Click Moka Fresh Menu', {});
}

export function startShopping() {
  pushClevertapEvent('Start Shopping', {});
}
